import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

i18n
    .use(initReactI18next) // předá i18n instance do react-i18next
    .init({
        resources: {
            cs: {
                translation: {
                    login: "Přihlásit se",
                    loginToErp: 'CMS marierottrova.cz',
                    typeYourPassword: "Zadejte heslo",
                    typeYourEmail: "Zadejte email",
                    didUForgotPassword: "Zapomněli jste heslo?",
                    passwordRecovery: "Obnova zapomenutého hesla",
                    send: 'Odeslat',
                    backToLogin: 'Zpět na přihlášení',
                    remember: 'Zapamatovat',
                    createdAt: 'Vytvořeno',
                    save: 'Uložit',
                    password: 'Heslo',
                    resetTokenNoteVerified: 'Token na obnovu hesla je neplatný',
                    passwordConfirmation: 'Heslo znovu',
                    email: 'Email',
                    mobile: 'Mobil',
                    setNewPassword: 'Nastavte si nové heslo',
                    concerts: {
                        label: 'Koncerty',
                        addConcert: 'Přidat koncert',
                        editConcert: 'Upravit koncert',
                        location: 'Místo',
                        date: 'Datum',
                        ticketUrl: 'URL vstupenky',
                        ticket: 'vstupenka',
                        description: 'Popis',
                        slug: 'URL'
                    },
                    generalSettings: {
                        general: 'Základní nastavení',
                        smtpSettings: 'SMTP nastavení',
                        label: 'Obecná nastavení',
                        host: 'Host',
                        user: 'Uživatel',
                        password: 'Heslo',
                        security: 'Zabezpečení',
                        facebookUrl: 'Facebook URL',
                        instagramUrl: 'Instagram URL',
                        contactDetails: 'Kontaktní informace (stránka Kontakt)',
                        merchUrl: 'Merchandising URL',
                        albumUrl: 'Alba URL',
                        facebookName: 'Název Facebook účtu',
                        instagramName: 'Název Instagram účtu',
                        contactInformation: 'Kontaktní informace',
                        curriculumVitae: 'O Marii'
                    },
                    users: {
                        label: 'Uživatelé',
                        addUser: 'Přidat uživatele',
                        profiles: 'Uživatelské profily',
                        lastSignIn: 'Poslední přihlášení',
                        name: 'Jméno',
                        surname: 'Příjmení',
                        editUser: 'Upravit uživatele',
                        sendResetLink: 'Odeslat email na obnovu hesla'
                    },
                    lyrics: {
                        label: 'Texty písní',
                        categories: 'Alba',
                        items: 'Testy písní',
                        add: 'Přidat text písně',
                        name: 'Název písne',
                        album: 'Album',
                        text: 'Text',
                        albums: 'Alba',
                        description: 'Popis'
                    },
                    lyricsCategories: {
                        add: 'Vytvořit album',
                        slug: 'URL',
                        name: 'Název',
                        edit: 'Úprava alba'
                    },
                    discography: {
                        cover: 'Obrázek',
                        type: 'Typ',
                        albumName: 'Název alba',
                        itemName: 'Název skladby',
                        label: 'Diskografie',
                        addAlbum: 'Přidat album',
                        addItem: 'Přidat skladbu',
                        searchByName: 'Hledat dle názvu',
                        albums: 'Alba',
                        album: 'Album',
                        host: 'Host',
                        music: 'Hudba',
                        czechLyrics: 'Český text',
                        items: 'Skladby',
                        lp: 'LP',
                        mc: 'MC',
                        cd: 'CD',
                        sp: 'SP',
                        deleteCover: 'Smazat obrázek',
                        year: 'Rok',
                        editAlbum: 'Úprava alba',
                        purchaseUrl: 'URL pro nákup',
                        description: 'Popis alba',
                        name: 'Název',
                        songList: 'Seznam písní'
                    },
                    blog: {
                        label: 'Blog',
                        title: 'Titulek',
                        publishedAt: 'Publikovat',
                        text: 'Obsah',
                        add: 'Přidat příspěvek',
                        onlyActive: 'Pouze aktivní',
                        active: 'Aktivní'
                    },
                    yes: 'Ano',
                    no: 'Ne',
                    clearFilters: 'Smazat filtry',
                    search: 'Hledat',
                    updatedAt: 'Upraveno',
                    passwordDoesntMatch: 'Hesla se neshodují',
                    URLDuplicityError: 'Položka s touto URL již existuje',
                }
            }
        }, lng: "cs", fallbackLng: "cs", interpolation: {
            escapeValue: false
        }
    });

export default i18n;
